
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { LoginService } from '../../login/login.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { or, RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ReportsService } from '../_services/reports.service';
import { Report } from '../_types/report';
import { DatasetsService } from '../_services/datasets.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { DatasetsFieldsService } from '../_services/datasets-fields.service';
import { ReportsUsersGroupsPermissionsService } from '../_services/reports-users-groups-permissions.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ReportsUsersGroupsPermissionsComponent } from './reports-users-groups-permissions/reports-users-groups-permissions.component';

@Component({
    selector: 'app-reports-detail',
    templateUrl: './reports-detail.component.html',
    styleUrls: ['./reports-detail.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ReportsDetailComponent implements OnInit {

  public reportFormGroup!: RxFormGroup;

  public report: Report = new Report;
  public totalRecords: number = 0;
  public loading: boolean = false;
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public datasets: any[] = [];
  public columns: any[] = [];
  public datasetsFields: any[] = [];
  public config: any = {
    filters: [{}],          
    columns: [],
    group: [],
    orderBy: []      
  };
  
  public selectedColumns: any = [];
  public selectedOrderByColumns: any = [];
  public selectedGroupByColumns: any = [];
  private lastGridEvent: any;
  public params: any = {};
  public arrayYesNo: any = [
    {
      id: "false",
      name: "No"
    },{
      id: "true",
      name: "Sí"
    }
  ];

  public arrayDates: any = [
    {
      id: "CUSTOM",
      name: "Especificar fecha"
    },
    {
      id: "TODAY",
      name: "Hoy"
    },
    {
      id: "MONTH",
      name: "Mes en curso"
    },
    {
      id: "YEAR",
      name: "Año en curso"
    }/*,
    {
      id: "PLUS7",
      name: "Hoy más 7 días"
    },
    {
      id: "LESS7",
      name: "Hoy menos 7 días"
    }*/
  ];

  public usersPermissions: any[] = [];
  public groupsPermissions: any[] = [];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public loginService: LoginService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private reportsService: ReportsService,
    private datasetsService: DatasetsService,
    private datasetsFieldsService: DatasetsFieldsService,
    private reportsUsersGroupsPermissions: ReportsUsersGroupsPermissionsService,
    private dialogService: DialogService
  ) {

  }

  async ngOnInit(): Promise<void> {

    await this.loadDatasets();

    this.route.paramMap.subscribe((params: ParamMap) => {
      let id: string | null = params.get('id');
      this.topbarService.setTitle("Detalles de informe");
      this.topbarService.addBreadcrumb("Informes", "/reports");
      this.reportFormGroup = this.formBuilder.formGroup<Report>(this.report) as RxFormGroup;
      if (id != null && id != '0') {
        this.loadReport(id);
        
      }

    });
    this.allowWrite = this.loginService.hasPermission("REPORTS.WRITE");
    this.allowDelete = this.loginService.hasPermission("REPORTS.DELETE");

  }

  async loadReport(id: string) {
    this.report = await firstValueFrom(this.reportsService.get(id)); 

    this.reportFormGroup.patchValue(this.report);
    
    await this.datasetSelected();

    await this.loadFilters();

    //await this.loadPermissions(id);
  }

  async loadFilters(){
    if (this.report.reportConfig != null) {
      // Usamos Promise.all() para manejar las promesas que devuelve el map
      this.config.filters = await Promise.all(
        this.report.reportConfig.filters.map(async (filter: any) => {
          const datasetField = this.datasetsFields.find(df => df.id === filter.datasetFieldId);
          const operators = datasetField ? this.operatorByType[datasetField?.optionsSql||datasetField?.optionsMode=='items'?"multiselect":datasetField.dataType] : [];

          let dropdownOptions = [];
  
          // ⚡ Si tiene SQL, carga las opciones desde el servidor
          if (datasetField?.optionsSql) {
            dropdownOptions = await this.loadDropdownOptions(datasetField.id);                        
          }

           // ⚡ Si tiene optionModel, carga las opciones del modelo
          if (datasetField?.optionsMode=='items') {
            dropdownOptions = JSON.parse(datasetField.optionsItems);
          }

          return {
            datasetFieldId: datasetField?.id || null,
            datasetField: datasetField?.name || null,
            label: filter?.label!=null?filter?.label:datasetField?.label || null,
            operator: filter.operator,
            value: datasetField?.optionsSql || datasetField?.optionsMode=='items' ? (filter.value ? filter.value.split(',') : []) : filter.value,              
            operators,
            dataType: datasetField?.dataType,
            dropdownOptions: dropdownOptions,
            askUser: filter.askUser
          };    
                    
        })
      );

      //hacemos esto para recorrer los nosmbres
      this.config.columns = await Promise.all(
        this.report.reportConfig.columns.map(async (column: any) => {
          const datasetField = this.datasetsFields.find(df => df.id === column.datasetFieldId);
         // console.log("datasetField Operator", datasetField);
          var column_return = column;
          column_return.datasetField = datasetField?.name || null;
          return column_return;
        })
      );   
      this.config.orderBy = await Promise.all(
        this.report.reportConfig.orderBy.map(async (column: any) => {
          const datasetField = this.datasetsFields.find(df => df.id === column.datasetFieldId);
          //console.log("datasetField Operator", datasetField);
          var column_return = column;
          column_return.datasetField = datasetField?.name || null;
          return column_return;
        })
      );
      this.config.group = await Promise.all(
        this.report.reportConfig.group.map(async (column: any) => {
          const datasetField = this.datasetsFields.find(df => df.id === column.datasetFieldId);
          //console.log("datasetField Operator", datasetField);
          var column_return = column;
          column_return.datasetField = datasetField?.name || null;
          return column_return;
        })
      );
     /* this.config.orderBy = this.report.reportConfig.orderBy;     
      this.config.group = this.report.reportConfig.group;  */    
    }
  }

  async loadDatasets() {

    let params: IParamsCollection = {      
    };

    let response = await firstValueFrom(this.datasetsService.all(params));
    this.datasets = response.data;    
  }
/*
  async loadPermissions(id: string) {

    let filters:any = {};
      filters.reportId = new Filter(FilterOperation.equals, 'reportId', '', id);
            
    let params: IParamsCollection = {      
      filter: FilterBuilder.fromObject(filters).build(),
      include: ['user', 'group']            
    };
    
    let response = await firstValueFrom(this.reportsUsersGroupsPermissions.all(params));
    this.usersPermissions = response.data.filter((m:any) => m.userId != null);
    this.groupsPermissions = response.data.filter((m:any) => m.groupId != null);

  }*/

  async datasetSelected() {

    
    let filters:any = {};
    filters.sourceId = new Filter(FilterOperation.equals, 'datasetId', '', this.report.datasetId);
            
    let params: IParamsCollection = {      
      filter: FilterBuilder.fromObject(filters).build()
    };
    
    let response = await firstValueFrom(this.datasetsFieldsService.all(params));    
    this.datasetsFields = response.data; 
        
  }
  

  // Cambia los operadores en función del tipo de dato seleccionado
  async onDatasetFieldChange(event: any, filter: any) {
    filter.dropdownOptions = [];
    const selectedField = this.datasetsFields.find(m=> m.id== event.value);            
    // Asigna los operadores disponibles según el dataType
    filter.operators = this.operatorByType[selectedField?.optionsSql||selectedField?.optionsMode=='items'?"multiselect":selectedField.dataType] || [];    
    // Reinicia el operador seleccionado
    filter.operator = '';      
    filter.dataType = selectedField.dataType;

    // Verificar si el campo tiene una consulta SQL
    if (selectedField?.optionsSql) {
      filter.dropdownOptions = await this.loadDropdownOptions(selectedField.id);            
    }   
     // ⚡ Si tiene optionModel, carga las opciones del modelo
    if (selectedField?.optionsMode=='items') {
      filter.dropdownOptions = JSON.parse(selectedField.optionsItems);
    }
 
    
  }

  async loadDropdownOptions(datasetField: string, filter: string = ""): Promise<any[]> {    
    let response = await firstValueFrom(this.datasetsFieldsService.getDropdownOptions(datasetField, {filter: filter}));    
    return response.result;
  }


  async save() {    
    let valid = this.formValidationService.validateForm(this.reportFormGroup);
    if (valid) {

      if(this.config.columns.length == 0){
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Debe seleccionar al menos una columna." });
        return;
      }

      this.report = Object.assign(this.report, this.reportFormGroup.value);
      this.report.reportConfig = this.config;     
      
      this.report.reportConfig= this.convertArrayValuesToString(this.config);
      let report = await firstValueFrom(this.reportsService.save(this.report));

      this.messageService.add({ closable: true, severity: 'success', summary: "Informe guardado correctamente." });

      this.router.navigate(['reports', 'visualization', report.id]);

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el informe?",
      header: "Eliminar informe",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.reportsService.delete(this.report.id).subscribe({
          next: () => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Informe eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['reports']);
  }

  addFilter() {
    this.config.filters.push({});
  }

  deleteFilter(i:number) {
    this.config.filters.splice(i, 1);
  }

  deleteColumnItem(item: any) {
    var i = 0;
    this.config.columns.forEach((element: any) => {
      if (element == item) {
        this.config.columns.splice(i, 1);
      }
      i++;
    });

    this.config.columns.forEach((col:any, index:any) => col.order = index + 1);
  }

  deleteOrderByItem(item: any){
    var i = 0;
    this.config.orderBy.forEach((element: any) => {
      if (element == item) {
        this.config.orderBy.splice(i, 1);
      }
      i++;
    });

    this.config.orderBy.forEach((col:any, index:any) => col.order = index + 1);
  }

  deleteGroupByItem(item: any){
    var i = 0;
    this.config.group.forEach((element: any) => {
      if (element == item) {
        this.config.group.splice(i, 1);
      }
      i++;
    });

    this.config.group.forEach((col:any, index:any) => col.order = index + 1);
  }

  onRowReorder(event: any, arrayToChange: string = 'columns') {
    let i = 1;
    if(arrayToChange === 'columns') {
      this.config?.columns.forEach((element: any) => {
        element.order = i;
        i++;
      });
    }else if(arrayToChange === 'orderBy') {
      this.config?.orderBy.forEach((element: any) => {
        element.order = i;
        i++;
      });
    }else if(arrayToChange === 'group') {
      this.config?.group.forEach((element: any) => {
        element.order = i;
        i++;
      });
    }

  }

  addColumns(tabOpen: boolean) {
    let i = this.config.columns.length;          

    //Comprobamos si los items mostrados están en la ordenación, sino está, se borra la ordenación-
    var existe = false;
    this.selectedColumns.forEach((item: any) => {
      const existe = this.config.columns.some((col:any) => col.datasetFieldId === item.id);
      if (!existe) {
          this.config.columns.push({
              type: item.type,
              order: this.config.columns.length + 1, 
              datasetFieldId: item.id,
              datasetField: item.name,
              label: item.label,
              aggregation: item.aggregation,
              value: item.value
          });
      }      
    }); 
    
    this.config.columns.forEach((col:any, index:any) => col.order = index + 1);
  }

  addOrderByItem(tabOpen: boolean) {
    let i = this.config.orderBy.length;            

    //Comprobamos si los items mostrados están en la ordenación, sino está, se borra la ordenación-
    var existe = false;
    this.selectedOrderByColumns.forEach((item: any) => {
      const existe = this.config.orderBy.some((col:any) => col.datasetFieldId === item.id);

      if (!existe) {
        this.config.orderBy.push({
            order: this.config.orderBy.length + 1, 
            datasetFieldId: item.id,
            datasetField: item.name,
            direction: item.direction,
            label: item.label
        });
      }      
    });     
    this.config.orderBy.forEach((col:any, index:any) => col.order = index + 1);
  }
  
  addGroupByItem(tabOpen: boolean) {
    let i = this.config.group.length;

    //Comprobamos si los items mostrados están en la ordenación, sino está, se borra la ordenación-
    var existe = false;
    this.selectedGroupByColumns.forEach((item: any) => {
      const existe = this.config.group.some((col:any) => col.datasetFieldId === item.id);
        if (!existe) {
            this.config.group.push({
                order: this.config.group.length + 1, 
                datasetFieldId: item.id,
                datasetField: item.name,
                label: item.label
            });
        }      
    });     
    this.config.group.forEach((col:any, index:any) => col.order = index + 1);
  }


  onReportTabOpen($event: any) {
    this.lastGridEvent = $event;

    if (this.config.columns == null || this.config.columns.length == 0) {
      this.messageService.add({ severity: "error", detail: "No has seleccionado ninguna columna" });
      this.loading = false;
      return;
    }
    if (this.report.id) {
      this.params = {
        _pageSize: $event.rows,
        _page: $event.first,
        _last: $event.last
      };
      this.loading = true;
      //params = Object.assign(params, this.report);
    }
  }  


  extractColumns(query: string): { label: string }[] {
    const selectPart = query.split('from')[0]; // Tomar solo la parte del SELECT
    const columnLines = selectPart
      .replace(/select/i, '') // Eliminar la palabra SELECT
      .split(',') // Dividir por comas
      .map((col) => col.trim()); // Eliminar espacios en blanco

    return columnLines.map((col) => {
      // Extraer alias o nombre principal
      const aliasMatch = col.match(/(\w+)\s+AS\s+(\w+)/i) || col.match(/(\w+)\.(\w+)/);
      const label = aliasMatch ? aliasMatch[2] || aliasMatch[1] : col;
      return { label };
    });
  }

  convertArrayValuesToString(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map(item => this.convertArrayValuesToString(item));
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (key === 'value' && Array.isArray(obj[key])) {
          obj[key] = obj[key].join(',');
        } else if (typeof obj[key] === 'object') {
          this.convertArrayValuesToString(obj[key]);
        }
      }
    }
    return obj;
  }
/*
  async editUserGroupPermission(type: string, reportUserGroupPermission: any) {
      let ref = this.dialogService.open(ReportsUsersGroupsPermissionsComponent, {
        closable: true,
        modal: true,
        header: 'Editar permisos',
        width: '500px',
        data: {
          reportUserGroupPermissionId: reportUserGroupPermission ? reportUserGroupPermission.id : null,
          reportId: this.report.id,
          type: type
        }
      });
  
      ref.onClose.subscribe((data: any) => {
        this.loadPermissions(this.report.id!);
      });
    }
  
    async deleteUserGroup(userGroupPermission:any){

    }
*/

  // Operadores por tipo de dato
  operatorByType: { [key: string]: { label: string, value: string }[] } = {
    bool: [
      /*{ label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' }*/
    ],
    string: [
      { label: 'Contiene (LIKE)', value: 'LIKE' },
      { label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' },
      { label: 'Es nulo', value: 'IS NULL' }
    ],
    date: [
      { label: 'Mayor o igual que', value: '>=' },
      { label: 'Mayor que', value: '>' },
      { label: 'Menor o igual que', value: '<=' },
      { label: 'Menor que', value: '<' },
      { label: 'Igual', value: '=' },
      { label: 'Es nulo', value: 'IS NULL' }
    ],
    number: [
      { label: 'Igual', value: '=' },
      { label: 'Distinto', value: '!=' },      
      { label: 'Mayor o igual que', value: '>=' },
      { label: 'Mayor que', value: '>' },
      { label: 'Menor o igual que', value: '<=' },
      { label: 'Menor que', value: '<' },
      { label: 'Es nulo', value: 'IS NULL' }
    ],
    multiselect: [
      { label: 'Contiene', value: 'IN' },
      { label: 'No contiene', value: 'NOT IN' },
      { label: 'Es nulo', value: 'IS NULL' }   
    ]
  };

}
